"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobx = require("mobx");
var _utils = require("@seedlang/utils");
var _constants = require("@seedlang/constants");
var _root_layout = _interopRequireDefault(require("./root_layout"));
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var DeckLayout = (_class = /*#__PURE__*/function (_RootLayout) {
  function DeckLayout() {
    var _this;
    _classCallCheck(this, DeckLayout);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DeckLayout, [].concat(args));
    _initializerDefineProperty(_this, "userInputExpanded", _descriptor, _this);
    _initializerDefineProperty(_this, "minimizedRatio", _descriptor2, _this);
    _initializerDefineProperty(_this, "sectionPadding", _descriptor3, _this);
    _initializerDefineProperty(_this, "debug", _descriptor4, _this);
    _this.heightForCardSections = function (numSections) {
      var padding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var excludeButton = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var totalPadding = numSections * padding;
      var buttonHeight = _this.keyboardVisible && excludeButton ? _this.buttonHeight + 10 : 0;
      return (_this.contentHeight - totalPadding + buttonHeight) / numSections;
    };
    _this.contentHeightWithMultipleChoiceButtons = function (numButtons) {
      return _this.deckHeightWithoutHeader - _this.totalMultipleChoiceButtonHeight(numButtons) - _this.sectionPadding * 3;
    };
    _this.totalMultipleChoiceButtonHeight = function (numButtons) {
      if (numButtons > 2) {
        return _this.multipleChoiceButtonHeight * 2 + _this.sectionPadding;
      }
      return _this.multipleChoiceButtonHeight;
    };
    _this.setUserInputExpanded = function (userInputExpanded) {
      _this.userInputExpanded = userInputExpanded;
    };
    return _this;
  }
  _inherits(DeckLayout, _RootLayout);
  return _createClass(DeckLayout, [{
    key: "cardArrowBoxHeight",
    get: function get() {
      return _constants.Layout.CARD_ARROW_BOX_HEIGHT;
    }
  }, {
    key: "cardArrowBoxWidth",
    get: function get() {
      return this.smallCardArrowBox ? 200 : _constants.Layout.CARD_ARROW_BOX_WIDTH;
    }
  }, {
    key: "smallCardArrowBox",
    get: function get() {
      return this.deckWidth < 460;
    }
  }, {
    key: "loaded",
    get: function get() {
      return (0, _utils.isPresent)(this.deckWidth);
    }
  }, {
    key: "triviaPlayersHeight",
    get: function get() {
      return this.minimumHeight ? 55 : 65;
    }
  }, {
    key: "triviaVideoSectionHeight",
    get: function get() {
      var notchPadding = this.hasNotch ? 30 : 0;
      var height = this.deckHeightWithoutHeader - notchPadding - this.triviaTextHeight - this.buttonHeight - this.triviaPlayersHeight - 30;
      return this.isAndroid ? height - 20 : height;
    }
  }, {
    key: "triviaVideoWidth",
    get: function get() {
      if (this.deckWidth) {
        var width = Math.floor(this.deckWidth / 1.5);
        return this.triviaVideoSectionHeight < width ? this.triviaVideoSectionHeight : width;
      }
      return 0;
    }
  }, {
    key: "triviaTextAndButtonsSectionHeight",
    get: function get() {
      return this.triviaTextHeight + this.buttonHeight;
    }
  }, {
    key: "triviaTextHeight",
    get: function get() {
      return this.minimumHeight ? 155 : 175;
    }
  }, {
    key: "deckHeight",
    get: function get() {
      if (this.isNative) {
        return this.nativeDeckHeight;
      }
      return this.viewportHeight - 20;
    }
  }, {
    key: "nativeDeckHeight",
    get: function get() {
      var height;
      if (this.keyboardVisible && (0, _utils.isPresent)(this.keyboardHeight)) {
        height = this.viewportHeight + this.topInsetHeight - this.keyboardHeight;
      } else {
        height = this.isAndroid ? this.viewportHeight + this.topInsetHeight : this.viewportHeight + this.topInsetHeight - 10;
      }
      return height - this.bottomInsetHeight - 30;
    }
  }, {
    key: "deckHeightWithoutHeader",
    get: function get() {
      return this.deckHeight - this.deckHeaderHeight;
    }
  }, {
    key: "innerDeckHeightWithoutHeader",
    get: function get() {
      return this.deckHeightWithoutHeader - this.sectionPadding * 2;
    }
  }, {
    key: "quarterDeckWidth",
    get: function get() {
      return Math.floor(this.deckWidth / 4);
    }
  }, {
    key: "maximumFontSize",
    get: function get() {
      if (this.maximumHeight) {
        return _constants.Layout.MAX_MAXIMUM_CARD_TEXT_FONT_SIZE;
      }
      if (this.minimumHeight) {
        return _constants.Layout.MAX_MINIMUM_CARD_TEXT_FONT_SIZE;
      }
      return _constants.Layout.MAX_DEFAULT_CARD_TEXT_FONT_SIZE;
    }
  }, {
    key: "deckWidth",
    get: function get() {
      if (this.isMobile || this.isNative) {
        return this.viewportWidth;
      }
      return this.deckHeight * 0.60;
    }
  }, {
    key: "cardTextHeight",
    get: function get() {
      return this.cardTextHasMinimumHeight ? this.minimumCardTextHeight : Math.floor(_constants.Layout.MINIMUM_VIDEO_TEXT_HEIGHT + this.cardTextGap);
    }
  }, {
    key: "cardTextGap",
    get: function get() {
      return Math.max(0, this.deckHeight - this.sumOfMinimumComponentHeights);
    }
  }, {
    key: "sumOfMinimumComponentHeights",
    get: function get() {
      return this.deckHeaderHeight + this.innerDeckWidth + _constants.Layout.MINIMUM_VIDEO_TEXT_HEIGHT + this.userInputHeight + this.buttonHeight + this.sectionPadding * 3;
    }
  }, {
    key: "innerDeckWidth",
    get: function get() {
      return this.deckWidth - this.sectionPadding * 2;
    }
  }, {
    key: "supplementBottom",
    get: function get() {
      return 20;
    }
  }, {
    key: "deckHeaderHeight",
    get: function get() {
      if (this.maximumHeight) {
        return _constants.Layout.MAXIMUM_DECK_HEADER_HEIGHT + this.topPadding;
      }
      if (this.minimumHeight) {
        return _constants.Layout.MINIMUM_DECK_HEADER_HEIGHT + this.topPadding;
      }
      if (this.isMobile) {
        return _constants.Layout.MOBILE_DECK_HEADER_HEIGHT + this.topPadding;
      }
      return _constants.Layout.DESKTOP_DECK_HEADER_HEIGHT + this.topPadding;
    }
  }, {
    key: "topPadding",
    get: function get() {
      return this.topInsetHeight > 0 ? this.topInsetHeight - 20 : 0;
    }
  }, {
    key: "hasNotch",
    get: function get() {
      return this.topInsetHeight > 0;
    }
  }, {
    key: "cardHeight",
    get: function get() {
      return this.deckHeight - this.deckHeaderHeight;
    }
  }, {
    key: "supplementWidth",
    get: function get() {
      return Math.floor(this.videoHeight / this.minimizedRatio);
    }
  }, {
    key: "contentHeight",
    get: function get() {
      var buttonHeight = this.buttonHeight;
      var padding = this.sectionPadding * 3;
      return this.deckHeight - this.deckHeaderHeight - buttonHeight - padding;
    }
  }, {
    key: "videoHeight",
    get: function get() {
      var padding = this.cardTextGap > 0 ? 0 : 10;
      return Math.floor(Math.min(this.contentHeight - this.userInputHeight - this.cardTextHeight - padding, this.innerDeckWidth));
    }
  }, {
    key: "contentHeightWithoutButtons",
    get: function get() {
      return this.deckHeight - this.deckHeaderHeight;
    }
  }, {
    key: "describeContentHeight",
    get: function get() {
      return this.contentHeight - this.userInputHeight;
    }
  }, {
    key: "overlayHeight",
    get: function get() {
      var overlayHeight = this.deckHeight - this.deckHeaderHeight;
      return this.keyboardVisible && this.keyboardHeight ? overlayHeight - this.keyboardHeight : overlayHeight;
    }
  }, {
    key: "showUserInput",
    get: function get() {
      return this.isChrome || this.isFirefox || this.isNative;
    }
  }, {
    key: "buttonHeight",
    get: function get() {
      if (this.maximumHeight) {
        return _constants.Layout.MAXIMUM_BUTTON_HEIGHT;
      }
      if (this.minimumHeight) {
        return _constants.Layout.MINIMUM_BUTTON_HEIGHT;
      }
      return _constants.Layout.DESKTOP_BUTTON_HEIGHT;
    }
  }, {
    key: "multipleChoiceButtonHeight",
    get: function get() {
      if (this.maximumHeight) {
        return _constants.Layout.MAXIMUM_MULTIPLE_CHOICE_BUTTON_HEIGHT;
      }
      if (this.minimumHeight) {
        return _constants.Layout.MINIMUM_MULTIPLE_CHOICE_BUTTON_HEIGHT;
      }
      return _constants.Layout.MULTIPLE_CHOICE_BUTTON_HEIGHT;
    }
  }, {
    key: "maximumHeight",
    get: function get() {
      return this.viewportHeight > 899;
    }
  }, {
    key: "userInputHeight",
    get: function get() {
      var height = this.minimumHeight ? _constants.Layout.MINIMUM_USER_INPUT_HEIGHT : _constants.Layout.USER_INPUT_HEIGHT;
      return this.userInputExpanded && this.isNative ? height * 2 : height;
    }
  }, {
    key: "minimumCardTextHeight",
    get: function get() {
      if (this.minimumHeight) {
        return _constants.Layout.MINIMUM_VIDEO_TEXT_HEIGHT;
      }
      if (this.maximumHeight) {
        return _constants.Layout.MAXIMUM_VIDEO_TEXT_HEIGHT;
      }
      return _constants.Layout.VIDEO_TEXT_HEIGHT;
    }
  }, {
    key: "cardTextHasMinimumHeight",
    get: function get() {
      return this.cardTextGap <= 0;
    }
  }, {
    key: "audioBottom",
    get: function get() {
      return this.buttonHeight;
    }
  }, {
    key: "cardTextTop",
    get: function get() {
      return this.deckHeight - (this.videoHeight + this.deckHeaderHeight);
    }
  }, {
    key: "cardTextBottom",
    get: function get() {
      return this.buttonHeight + this.userInputHeight;
    }
  }]);
}(_root_layout["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "userInputExpanded", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "minimizedRatio", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 3;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "sectionPadding", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 10;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "debug", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "cardArrowBoxHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "cardArrowBoxHeight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cardArrowBoxWidth", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "cardArrowBoxWidth"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "smallCardArrowBox", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "smallCardArrowBox"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loaded", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "loaded"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "triviaPlayersHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "triviaPlayersHeight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "triviaVideoSectionHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "triviaVideoSectionHeight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "triviaVideoWidth", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "triviaVideoWidth"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "triviaTextAndButtonsSectionHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "triviaTextAndButtonsSectionHeight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "triviaTextHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "triviaTextHeight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deckHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "deckHeight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nativeDeckHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "nativeDeckHeight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deckHeightWithoutHeader", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "deckHeightWithoutHeader"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "innerDeckHeightWithoutHeader", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "innerDeckHeightWithoutHeader"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "quarterDeckWidth", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "quarterDeckWidth"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "maximumFontSize", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "maximumFontSize"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deckWidth", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "deckWidth"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cardTextHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "cardTextHeight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cardTextGap", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "cardTextGap"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sumOfMinimumComponentHeights", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "sumOfMinimumComponentHeights"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "innerDeckWidth", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "innerDeckWidth"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "supplementBottom", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "supplementBottom"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deckHeaderHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "deckHeaderHeight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "topPadding", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "topPadding"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasNotch", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasNotch"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cardHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "cardHeight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "supplementWidth", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "supplementWidth"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "contentHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "contentHeight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "videoHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "videoHeight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "contentHeightWithoutButtons", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "contentHeightWithoutButtons"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "describeContentHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "describeContentHeight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "overlayHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "overlayHeight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showUserInput", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showUserInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "buttonHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "buttonHeight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "multipleChoiceButtonHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "multipleChoiceButtonHeight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "maximumHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "maximumHeight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userInputHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userInputHeight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "minimumCardTextHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "minimumCardTextHeight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cardTextHasMinimumHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "cardTextHasMinimumHeight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "audioBottom", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "audioBottom"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cardTextTop", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "cardTextTop"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cardTextBottom", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "cardTextBottom"), _class.prototype), _class);
var _default = exports["default"] = DeckLayout;